import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=e5612fb4&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=e5612fb4&prod&lang=css"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=e5612fb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5612fb4",
  null
  
)

export default component.exports